var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-group",class:[_vm.columns&&("columns-" + _vm.columns),{border: _vm.border,'grid-line':_vm.gridLine}]},[_c('div',{staticClass:"inner"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }